declare global {
  interface Window {
    Shopify?: {
      routes?: {
        root?: string
      }
    }
  }
}

export function buildShopifyRoute(root: string, path: string): string {
  return `${root}${path.replace(/^\//, '')}`
}

export function shopifyRoute(path: string): string {
  const root = window.Shopify?.routes?.root ?? '/'
  return buildShopifyRoute(root, path)
}
